import { Box, Typography } from '@mui/joy';

// One labelled block inside a filter drawer.
export function FilterSection({ title, children }) {
  return (
    <Box>
      <Typography level="title-xs" sx={{ mb: 1 }}>{title}</Typography>
      {children}
    </Box>
  );
}
